import { useEffect, useState } from "react";

import { getStats, getActivity } from "./services";
import { getTrackingNumberIds } from "./helpers";

export default ({ trackingNumbers, selectedTrackingNumbers, minDate, maxDate }) => {
  const [stats, setStats] = useState({});
  const [activity, setActiviy] = useState([]);
  // Loading states
  const [loadingStats, setLoadingStats] = useState(false);
  const [loadingActivity, setLoadingActivity] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        setLoadingStats(true);
        const results = await getStats(
          getTrackingNumberIds(selectedTrackingNumbers, trackingNumbers),
          minDate,
          maxDate,
        );
        setStats(mapStats(results));
      } finally {
        setLoadingStats(false);
      }
    };

    load();
  }, [selectedTrackingNumbers, minDate, maxDate]);

  useEffect(() => {
    const load = async () => {
      try {
        setLoadingActivity(true);
        const results = await getActivity(
          getTrackingNumberIds(selectedTrackingNumbers, trackingNumbers),
          minDate,
          maxDate,
        );
        setActiviy(results);
      } finally {
        setLoadingActivity(false);
      }
    };

    load();
  }, [selectedTrackingNumbers, minDate, maxDate]);

  return { activity, stats, loadingStats, loadingActivity };
};

const mapStats = (stats) => {
  return {
    trackingNumbers: stats.tracking_numbers.map((tn) => ({
      id: tn.id,
      name: tn.name,
      totalCalls: tn.total_calls,
      totalTexts: tn.total_texts,
      createdAt: tn.created_at,
      totalLeads: tn.total_leads,
    })),
    totalTexts: stats.total_texts,
    totalCalls: stats.total_calls,
    missedCalls: stats.missed_calls,
    talkedCalls: stats.talked_calls,
    totalCallDuration: stats.total_call_duration,
    totalCallsWithDuration: stats.total_calls_with_duration,
    totalNewLeads: stats.total_new_leads,
  };
};
